import { Box, Table, Text } from "@mantine/core";
import {
  setPage,
  setTake,
  useSelectActivityLog,
  useSelectPageActivityLog,
  useSelectTakeActivityLog,
  useSelectTotalCountActivityLog,
} from "../../../redux/features/activityLog/activityLogSlice";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { AppPagination } from "../../../components/AppPagination/AppPagination";
import { TableNoResults } from "../../../components/TableNoResults/TableNoResults";
import { useIsMutating, useMutationState } from "@tanstack/react-query";
import { TableSkeletonActivityLog } from "../../../components/Skeletons/TableSkeletonActivityLog";
import { dateWithHourFormat } from "../../../utils/dateFormat";
import dayjs from "dayjs";

const ActivityLogTable = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const page = useSelectPageActivityLog();
  const take = useSelectTakeActivityLog();
  const totalCount = useSelectTotalCountActivityLog();
  const activityLog = useSelectActivityLog();

  const isFetching = useIsMutating({
    mutationKey: ["fetch-activity-log"],
  });

  const { error } = useMutationState({
    mutationKey: ["fetch-activity-log"],
  });

  const handlePageChange = (newPage) => {
    dispatch(setPage(newPage - 1));
  };

  const handleTakeChange = (newSize) => {
    dispatch(setTake(newSize));
  };

  const rows = activityLog.map((log) => (
    <Table.Tr key={log.id}>
      <Table.Td>{log.description}</Table.Td>
      <Table.Td>
        {log.dateTime ? dayjs(log.dateTime).format(dateWithHourFormat) : ""}
      </Table.Td>
      <Table.Td>{log.userName}</Table.Td>
      <Table.Td>{log.userRole}</Table.Td>
      <Table.Td>{log.menu}</Table.Td>
    </Table.Tr>
  ));

  if (error) {
    return (
      <Box>
        <Text pt={30} ta="center">
          Error
        </Text>
      </Box>
    );
  }

  return (
    <>
      <Box className="table-panel">
        {isFetching > 0 ? (
          <TableSkeletonActivityLog length={take} />
        ) : (
          <Table horizontalSpacing="md" stickyHeader pb={100}>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>{t("activity.activity")}</Table.Th>
                <Table.Th>{t("activity.date")}</Table.Th>
                <Table.Th>{t("activity.user")}</Table.Th>
                <Table.Th>{t("activity.role")}</Table.Th>
                <Table.Th>{t("activity.menu")}</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {activityLog.length === 0 ? <TableNoResults colSpan={5} /> : rows}
            </Table.Tbody>
          </Table>
        )}
      </Box>
      {totalCount > 0 && (
        <AppPagination
          onPageChange={handlePageChange}
          onTakeChange={handleTakeChange}
          page={page}
          take={take}
          total={totalCount}
        />
      )}
    </>
  );
};

export default ActivityLogTable;
